import styled from 'styled-components';

import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Question = styled.div`
  ${fontStyle('lg')};
  color: ${({ theme }) => theme.colors.black};
  font-weight: ${fontWeight('bold')};
  margin-bottom: ${spacing('lg')};
`;

export const $Paragraphe = styled.p`
  ${fontStyle('base')};
  color: ${({ theme }) => theme.colors.black};
  font-weight: ${fontWeight('normal')};
  padding-bottom: ${spacing('xxl')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.disabled};
`;
